<template>
  <v-layout id="screen-log">
    <div>
      <v-navigation-drawer
        ref="drawer"
        permanent
        hide-overlay
        :height="sidebar.height"
        :width="sidebar.width"
      >
        <div class="sidetab-content">
          <v-tabs class="tab-select-bar" grow v-model="active_tab">
            <v-tab
              v-for="tab of tabs"
              :key="tab.id"
              v-on:click="getDataLeftPanel(tab.id, true)"
            >
              {{ tab.name }}
            </v-tab>
          </v-tabs>
          <v-data-table
            v-if="this.dataSidebarAvailable"
            dense
            class="mr-2 elevation-2"
            multi-sort
            :headers="this.tabSidebar.headers"
            :items="this.tabSidebar.items"
            item-key="id"
            :search="search"
            :footer-props="{ 'items-per-page-options': [30, 50, 100, -1] }"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                clearable
                label="Recherche"
                class="mx-4"
              ></v-text-field>
            </template>
            <template v-slot:item.id="{ item }">
              <v-icon v-on:click="selectItem(item)"
                >{{
                  item.id === tabSidebar.itemSelected.id
                    ? 'fas fa-circle'
                    : 'far fa-circle'
                }}
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-navigation-drawer>
    </div>

    <div ref="separator" class="separator">
      <v-icon v-on:click="hideShowSidebar"
        >{{
          sidebar.expanded
            ? 'far fa-caret-square-left'
            : 'far fa-caret-square-right'
        }}
      </v-icon>
    </div>

    <div>
      <div
        :style="{
          width: this.contentright.width + 'px',
          height: this.contentright.height + 'px',
        }"
        ref="drawer2"
      >
        <div v-if="this.datacontentrightAvailable" class="contentright">
          <!-- JXCEL -->
          <div
            v-if="
              user != null &&
              this.contentright.width != 0 &&
              this.contentright.height != 0 &&
              this.tabRight.data != null
            "
          >
            <Jexcel
              v-bind:user="this.user"
              v-bind:widthJexcel="this.contentright.width"
              v-bind:heightJexcel="this.contentright.height"
              v-bind:dataSet="this.tabRight.data"
              v-bind:conf="onglet"
              v-on:event-dispatcher="eventDispatch"
              v-on:message-response="toasterThrow"
              v-on:json-jexcel="sendModifiation"
            />
          </div>
        </div>
        <div v-else>
          <div
            :style="{ top: this.contentright.height / 2 + 'px' }"
            v-if="displaySuggestion"
            class="suggestion"
          >
            Veuillez sélectionner une entrée sur le panneau de gauche
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.processing || this.processingDataLeftPanel">
      <v-overlay :z-index="zIndex" :value="overlay"
        ><spinner
          class="spinner-tab"
          :message="messageSpinner"
          :displayInfos="false"
      /></v-overlay>
    </div>
  </v-layout>
</template>

<script>
import Spinner from '@/components/AppSpinner';
import Jexcel from '@/components/jExcelTable/jExcel';
import ConfOnglet from './ConfOngletsModifScenario';
export default {
  components: {
    Spinner,
    Jexcel,
  },
  props: ['user', 'ongletIndex'],
  data: function () {
    return {
      search: '',
      onglet: null,
      tabs: null,
      displaySuggestion: false,
      processing: false,
      active_tab: 0,
      processingDataLeftPanel: false,
      documentHeight: 0,
      documentWidth: 0,
      messageSpinner: '',
      overlay: true,
      zIndex: 9999,
      dataSidebarAvailable: false,
      datacontentrightAvailable: false,
      el: null,
      sidebarElement: null,
      sidebar: {
        expanded: true,
        width: 0,
        maxWidth: 0,
        height: 0,
        sidebarWidthTmp: 0,
      },
      contentright: {
        width: 0,
        height: 0,
      },
      tabRight: {
        data: null,
      },
      tabSidebar: {
        itemSelected: {
          id: '',
        },
        items: [],
        headers: null,
      },
    };
  },
  methods: {
    async getDataLeftPanel(key, noId) {
      var cle = key;

      if (noId == true) {
        this.tabSidebar.itemSelected.id = '';
      }

      this.processingDataLeftPanel = true;
      this.messageSpinner = 'Chargement données panneau latéral';
      this.dataSidebarAvailable = false;
      this.datacontentrightAvailable = false;
      var proc = this.onglet['procedurePanel'];
      axios({
        method: 'get',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_MODIF_SC_GET_LEFT_PANEL,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        params: {
          modeIn: this.onglet['modeIn'][cle],
          procedureName: proc,
        },
      })
        .then((response) => {
          if(response.data.data.length == 0){
            this.$emit(
            'message-response',
            'Pas de données pour le panneau latéral de l\'onglet',
            -1,
            true,
            9000
          );
          }
          this.processingDataLeftPanel = false;
          this.tabSidebar.headers = this.buildHeaders(response.data.display);
          this.tabSidebar.items = response.data.data;
          this.dataSidebarAvailable = true;
        })
        .catch((error) => {
          this.tabSidebar.items = [];
          this.processingDataLeftPanel = false;
          this.$emit(
            'message-response',
            'Erreur serveur lors du chargement des données du panneau latéral',
            -1,
            true,
            9000
          );
          this.dataSidebarAvailable = true;
        })
        .finally(() => {
          this.displaySuggestionFunc();
        });
    },
    async selectItem(item) {
      this.datacontentrightAvailable = false;
      this.processing = true;
      this.messageSpinner = 'Chargement données du tableau';
      this.tabSidebar.itemSelected = item;
      this.displaySuggestion = false;
      var type = this.onglet['modeIn'][this.active_tab];
      var proc = this.onglet['procedureJexcel'];
      axios({
        method: 'get',
        url:
          process.env.VUE_APP_BASE_URL +
          process.env.VUE_APP_MODIF_SC_GET_JEXCEL_DATA_RIGHT_TAB,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        params: {
          inId: this.tabSidebar.itemSelected.id,
          type: type,
          procedureName: proc,
        },
      })
        .then((response) => {
          this.tabRight.data = response.data;
          this.datacontentrightAvailable = true;
          this.processing = false;
        })
        .catch((error) => {
          this.processing = false;
          this.$emit(
            'message-response',
            'Erreur serveur lors du chargement des données du panneau droit',
            -1,
            true,
            9000
          );
          this.datacontentrightAvailable = true;
        })
        .finally(() => {});
    },
    async sendModifiation(objet) {
      this.processing = true;
      var proc = this.onglet['procedureModifBdd'];
      this.messageSpinner = 'Prise en compte de vos modifications en cours';
      let json = JSON.stringify(objet);
      let flagError = false;
      let flagStatus;
      await axios({
        method: 'post',
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_MODIF_SC_POST,
        headers: {
          'Content-Type': 'application/json',
          user: this.user.email,
        },
        data: {
          jsonIn: json,
          procedureName: proc,
        },
      })
        .then((response) => {
          flagStatus = response.data.status;
          this.$emit(
            'message-response',
            response.data.message,
            response.data.status,
            true,
            600000
          );
        })
        .catch((error) => {
          flagError = true;
          this.$emit(
            'message-response',
            'Erreur du serveur lors de la modification des données',
            -1,
            true,
            9000
          );
          this.datacontentrightAvailable = true;
        }).finally(() => {
          this.$store.dispatch('fetchUserInfos')
        });;

      if (!flagError && flagStatus == 1) {
        this.datacontentrightAvailable = false;
        await this.getDataLeftPanel(this.active_tab, false);
      }

      let itemAvailable = false;
      this.tabSidebar.items.forEach((item) => {
        if (this.tabSidebar.itemSelected.id == item.id) {
          itemAvailable = true;
          this.tabSidebar.itemSelected = item;
        }
      });
      if (itemAvailable && !flagError && flagStatus == 1) {
        this.selectItem(this.tabSidebar.itemSelected);
      } else {
        //this.tabSidebar.itemSelected.id = '';
      }
      this.processing = false;
    },
    eventDispatch(event, data) {
      if (event == 'message-response') {
        this.toasterThrow(data[0], data[1], data[2], data[3]);
      } else {
        this.sendModifiation(data[0]);
      }
    },
    toasterThrow(message, status, flag, timeout) {
      this.$emit('message-response', message, status, flag, timeout);
    },
    onWindowsResize(e) {
      this.updateConstantes();
    },
    hideShowSidebar() {
      this.sidebar.expanded = !this.sidebar.expanded;
      if (!this.sidebar.expanded) {
        this.sidebar.width = 0;
      } else {
        this.sidebar.width = this.sidebar.sidebarWidthTmp;
      }
    },
    resize(e) {
      if (e.clientX < this.maxWidth) {
        document.body.style.cursor = 'ew-resize';
        this.sidebarElement.style.width = e.clientX + 'px';
        this.contentright.width = this.documentWidth - e.clientX - 60;
      }
    },
    setBorderWidth() {
      this.el.style.cursor = 'ew-resize';
      this.el.style.backgroundColor = 'orange';
      this.el.width = '60px';
      var rect = this.el.getBoundingClientRect();
      this.sidebar.height =
        this.documentHeight - rect.top - this.documentHeight / 20;
    },
    updateConstantes() {
      this.documentWidth = window.innerWidth;
      this.documentHeight = window.innerHeight;
      this.sidebar.sidebarWidthTmp = this.documentWidth / 3;
      this.maxWidth = this.documentWidth / 2;
      this.contentright.width = this.documentWidth - 60 - this.sidebar.width;
    },
    setConstantes() {
      this.documentWidth = window.innerWidth;
      this.documentHeight = window.innerHeight;
      this.el = this.$refs['separator'];
      this.sidebarElement = this.$refs.drawer.$el;
      this.sidebar.sidebarWidthTmp = this.documentWidth / 3;
      this.maxWidth = this.documentWidth / 2;
      this.contentright.width =
        this.documentWidth - 60 - this.sidebar.sidebarWidthTmp;
    },
    setEvents() {
      const sidebar = this.$refs.drawer.$el;
      const contentelement = this.$refs['drawer2'];
      const el = this.$refs['separator'];

      window.addEventListener('resize', this.onWindowsResize);

      el.addEventListener(
        'mousedown',
        (e) => {
          if (this.sidebar.expanded !== false) {
            el.style.transition = 'initial';
            sidebar.style.transition = 'initial';
            contentelement.style.transition = 'initial';
            document.addEventListener('mousemove', this.resize, true);
          }
        },
        false
      );
      document.addEventListener(
        'mouseup',
        (e) => {
          el.style.transition = '';
          sidebar.style.transition = '';
          contentelement.style.transition = '';
          document.body.style.cursor = '';
          document.removeEventListener('mousemove', this.resize, true);
        },
        false
      );
    },
    waitResolveSeconds(millsec) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve('resolved');
        }, millsec);
      });
    },
    displaySuggestionFunc() {
      if (this.tabSidebar.itemSelected.id == '') {
        this.displaySuggestion = true;
      }
    },
    buildHeaders(data) {
      var headers = [];
      for (var i = 0; i < data.length; i++) {
        var key;
        var value;
        for (const [k, v] of Object.entries(data[i])) {
          key = k;
          value = v;
        }
        let obj = new Object();
        obj.text = value;
        obj.value = key;
        obj.align = 'center';
        headers.push(obj);
      }
      let obj = new Object();
      obj.text = '';
      obj.value = 'id';
      obj.align = 'center';
      obj.sortable = false;
      headers.push(obj);
      return headers;
    },
  },
  watch: {
    dataSidebarAvailable: function () {
      this.sidebar.width = this.sidebar.sidebarWidthTmp;
    },
    documentWidth: function () {
      this.sidebar.expanded = true;
      this.sidebar.width = this.sidebar.sidebarWidthTmp;
    },
    documentHeight: function () {
      this.sidebar.expanded = true;
      var rect = this.el.getBoundingClientRect();
      this.sidebar.height =
        this.documentHeight - rect.top - this.documentHeight / 20;
      this.contentright.height =
        this.documentHeight - rect.top - this.documentHeight / 20;
    },
  },
  mounted() {
    this.setConstantes();
    this.setBorderWidth();
    this.setEvents();
  },
  created() {
    this.onglet = ConfOnglet[this.ongletIndex];
    this.tabs = this.onglet['tabsPanel'];
    this.getDataLeftPanel(0, false);
  },
};
</script>

<style>
.noWidth {
  width: 0;
}

.scdf-yellow {
  margin-top: 10px;
}

.spinner-tab {
  margin-top: 30px;
}

.v-text-field {
  padding-right: 10px;
}

.contentright {
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
}

.sidetab-content {
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
}

.choice-message {
  color: black;
}

.dialog {
  z-index: 99999;
}

.suggestion {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
}
</style>